// `moment` is a webpack-exposed global from html/js/third_party, not a module
// import - it isn't present in every host page, so use it defensively.
declare const moment: any;

/**
 * Render a job's `finished_seconds_ago` as relative text ("3 minutes ago").
 *
 * The server sends an age rather than a timestamp, so there is no absolute time
 * to fall back on.
 */
export function formatRelativeTime(secondsAgo: number | null | undefined): string {
  if (secondsAgo === null || secondsAgo === undefined || !Number.isFinite(secondsAgo)) {
    return '\u2014';
  }

  const seconds = Math.max(0, Math.round(secondsAgo));

  if (typeof moment !== 'undefined') {
    return moment(new Date(Date.now() - seconds * 1000)).fromNow();
  }

  if (seconds < 60) {
    return seconds === 1 ? '1 second ago' : `${seconds} seconds ago`;
  }

  const minutes = Math.round(seconds / 60);
  if (minutes < 60) {
    return minutes === 1 ? '1 minute ago' : `${minutes} minutes ago`;
  }

  const hours = Math.round(minutes / 60);
  if (hours < 24) {
    return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
  }

  const days = Math.round(hours / 24);
  return days === 1 ? '1 day ago' : `${days} days ago`;
}
